import ExpertProfileEditModule from './expert-profile-edit.module'

export default ExpertProfileEditModule
